import { render, staticRenderFns } from "./label-field.vue?vue&type=template&id=218c9139&scoped=true&lang=pug"
import script from "./label-field.vue?vue&type=script&lang=js"
export * from "./label-field.vue?vue&type=script&lang=js"
import style0 from "./label-field.vue?vue&type=style&index=0&id=218c9139&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218c9139",
  null
  
)

export default component.exports